import { VALID_HOSTNAME_REGEX } from '@ipfabric/utils';
import { ipRegex } from '@sideway/address';
import { z } from 'zod';

export const hostnameSchema = z
  .string()
  .min(1, {
    message: 'Address is required',
  })
  .regex(
    VALID_HOSTNAME_REGEX,
    'Address must be a valid domain without a protocol',
  )
  .refine(
    (inputValue) => !/\.\d+$/.test(inputValue),
    '"tld" must not be a number',
  );
export const ipAddressSchema = z.string().refine((inputValue) => {
  const strippedBrackets = /^\[(.*)]$/.exec(inputValue);
  const normalizedValue = strippedBrackets ? strippedBrackets[1] : inputValue;
  return z
    .string()
    .regex(ipRegex({ cidr: 'forbidden' }).regex)
    .safeParse(normalizedValue).success;
});

export const addressSchema = z.string().refine(
  (value) => {
    return (
      hostnameSchema.safeParse(value).success ||
      ipAddressSchema.safeParse(value).success
    );
  },
  {
    message: 'Address must be a valid IPv4, IPv6 or domain without a protocol',
  },
);
